var _circle, _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEurs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 128,
    cy: 128,
    r: 128,
    fill: "#fff"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M216.829 220.16C240.978 196.878 256 164.193 256 128c0-42.772-20.979-80.643-53.207-103.887-44.378 5.07-81.248 25.7-93.993 55.242h119.04L214.4 110.08h-112s-.701 11.776-.64 17.28c.089 8.033.64 17.28.64 17.28h97.28l-12.8 29.703h-71.04c14.067 26.592 53.687 45.782 100.989 45.817Zm-37.354 25.069C163.723 252.155 146.311 256 128 256 57.308 256 0 198.692 0 128 0 57.308 57.308 0 128 0c11.727 0 23.085 1.577 33.875 4.53-41.443 7.585-75.521 36.399-90.68 74.825H44.8L31.36 110.08h33.92v14.08c0 2.352 0 3.119.016 3.885.033 1.509.128 3.016.412 16.595H43.52l-12.16 29.703h42.108c17.622 39.728 49.146 63.24 106.007 70.886Z",
    fill: "url(#a)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "a",
    x1: 30.08,
    y1: 203.52,
    x2: 224,
    y2: 52.48,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.333,
    stopColor: "#15BCFF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.664,
    stopColor: "#406BEE"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.925,
    stopColor: "#AE3EEB"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEurs);
export default __webpack_public_path__ + "static/media/eurs.71f02ccaa32044290d9dd2c47ce2aa04.svg";
export { ForwardRef as ReactComponent };